<template>
  <div id="app">
    <notifications
      group="foo"
      style="z-index: 99999"
      position="top center"
      :max="50"
      :ignoreDuplicates="true"
      v-if="$route.name != 'chart'"
    />
    <vue-confirm-dialog class="buySell-popup"></vue-confirm-dialog>
    <app-header v-show="$route.name != 'chart' && $route.name != 'chart-iq'"></app-header>
    <div class="" :class="$route.name != 'chart' ? 'mainWrapper' : ''">
      <router-view />
    </div>
  </div>
</template>

<script>
import "../static/website/js/bootstrap.min.js";
import header from "@/components/website/shared/header.vue";
import { ProviderCacheMixins } from "@/plugins/vue-provider-cache/mixin";
import * as types from "@/types";
import { Const } from "./plugins/commonAll/provider/lib/const.cls";
export default {
  name: "App",
  mixins: [ProviderCacheMixins],
  data() {
    return {
      tradeToggle: false,
      theme: false,
      isMobile: false
    };
  },
  watch: {
    theme(val) {
      if (val) {
        localStorage.setItem("app-theme", "dark-theme");
        this.$store.commit(Const.SET_APP_THEME, true);
        document.body.classList.remove("light-theme");
        document.body.classList.add("dark-theme");
      } else {
        localStorage.setItem("app-theme", "light-theme");
        this.$store.commit(Const.SET_APP_THEME, false);
        document.body.classList.add("light-theme");
        document.body.classList.remove("dark-theme");
      }
    },
  },
  components: {
    appHeader: header,
  },
  beforeCreate() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    // if (this.$route.query.token) {
    if (token) {
      let data = {
        // token: this.$route.query.token,
        token,
        loggedIn: true
      };
      this.$store.commit(types.SET_STATE, data);
      localStorage.setItem("user", btoa(JSON.stringify(data)));
      // this.$router.replace({ query: {}});
    }
  },
  mounted(){
    let isChartIq = localStorage.getItem("app-chart")
    if(isChartIq == 'chart-iq'){
      this.$store.commit(Const.SET_APP_CHART, true);
    }
  },
  created() {
    const _that = this
    window.isMobileCheck = false
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      _that.isMobile = true
      window.isMobileCheck = true
    }
    if (localStorage.getItem("app-theme")) {
      if (localStorage.getItem("app-theme") == "light-theme") this.theme = false;
      else if (localStorage.getItem("app-theme") == "dark-theme") this.theme = true;
    } else {
      this.theme = true;
    }
  },
};
</script>

<style>
@import "../static/website/css/bootstrap.min.css";
@import "../static/website/css/style.css";
@import "../static/website/css/less/responsive.css";
/*@import '~vue-simple-scrollbar/dist/vue-simple-scrollbar.css';*/
/* @import "../node_modules/overlayscrollbars/css/OverlayScrollbars.css"; */
/* @import "../static/website/css/stx-standard.css"; */
/* @import "../static/website/css/stx-chart.css"; */
@import "../static/website/css/font-awesome.css";
/*@import "../static/website/css/stx-advanced.css";*/
/*@import "../static/website/css/chartiq.css";*/
@import url('/static/website/chartiq/css/stx-chart.css');
@import url('/static/website/chartiq/css/normalize.css');
@import url('/static/website/chartiq/css/page-defaults.css');
@import url('/static/website/chartiq/css/chartiq.css');
@import url('/static/website/chartiq/css/webcomponents.css');
</style>



// WEBPACK FOOTER //
// src/App.vue